import { render, staticRenderFns } from "./documento_termos.vue?vue&type=template&id=09dee502&scoped=true&"
import script from "./documento_termos.vue?vue&type=script&lang=js&"
export * from "./documento_termos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dee502",
  null
  
)

export default component.exports